export const CAPACITY_SET_DIALOG_MAX_WIDTH = 500
